module.exports = __webpack_public_path__ + "img/res2.a45b2129.gif";